(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class announcementBar extends HTMLElement {
    constructor() {
      super();

      this.closedKey = 'promoClosed';

      if (!Shopify.designMode) {
        this.closeButton = this.querySelector('.announcement-close');
        if (this.closeButton) {
          this.closeButton.addEventListener('click', () => {
            sessionStorage.setItem(this.closedKey, 'true');
            this.remove();
            // Remove first: a detached element measures 0 high.
            this.setPromoHeight();
          });
        }
      }
    }

    connectedCallback() {
      if (this.classList.contains('swiper')) {
        this.initSwiper();
      }

      this.setPromoHeight();
      window.matchMedia('(max-width: 768px)').addEventListener('change', this.setPromoHeight.bind(this));

      this.adoptFreeShippingBanner();
    }

    // Global-e inserts its banner into <body> async, before or after this upgrades.
    adoptFreeShippingBanner() {
      const selector = 'body > .ge-free-shipping-container';
      const banner = document.querySelector(selector);
      if (banner) return this.addFreeShippingSlide(banner);

      this.freeShippingObserver = new MutationObserver(() => {
        const inserted = document.querySelector(selector);
        if (!inserted) return;
        this.freeShippingObserver.disconnect();
        this.addFreeShippingSlide(inserted);
      });
      this.freeShippingObserver.observe(document.body, { childList: true });
    }

    addFreeShippingSlide(banner) {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide announcement-bar-inner typography--body-1';
      slide.appendChild(banner);

      if (this.swiper) {
        // appendSlide rebuilds the loop duplicates; a plain appendChild would not.
        this.swiper.appendSlide(slide);
        return;
      }

      // A single-block bar is rendered without Swiper markup - give it some.
      let wrapper = this.querySelector('.swiper-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';
        this.querySelectorAll(':scope > .announcement-bar-inner').forEach((inner) => {
          inner.classList.add('swiper-slide');
          wrapper.appendChild(inner);
        });
        this.prepend(wrapper);
        this.classList.add('swiper');
      }
      wrapper.appendChild(slide);
      this.initSwiper();
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') return;

      const hasAutoplay = this.dataset.autoplay === 'true';
      const delay = Number(this.dataset.autoplayDuration) || 5000;

      this.swiper = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        grabCursor: true,
        loop: true,
        autoHeight: true,
        mousewheel: {
          forceToAxis: true
        },
        autoplay: hasAutoplay
          ? {
              delay,
              disableOnInteraction: false,
            }
          : false,
        on: {
          init: () => this.setPromoHeight(),
          slideChangeTransitionEnd: () => this.setPromoHeight(),
          resize: () => this.setPromoHeight(),
        },
      });
    }

    setPromoHeight() {
      document.documentElement.style.setProperty('--promo-height', `${this.offsetHeight}px`);

      // Header positions (global.js) otherwise only update on load/scroll/resize.
      if (typeof setCustomPropertiesOnResize === 'function') setCustomPropertiesOnResize();
    }
  }

  customElements.define('announcement-bar', announcementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  class CommunitySlider extends HTMLElement {
    connectedCallback() {
      if (typeof Swiper === 'undefined') return;

      const counter = this.closest('.community')?.querySelector('.community_counter');

      this.swiper = new Swiper(this, {
        slidesPerView: 1.3,
        spaceBetween: 10,
        watchOverflow: true,
        grabCursor: true,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
        },
        pagination: {
          el: counter,
          type: 'fraction',
        },
        breakpoints: {
          769: {
            spaceBetween: 16,
            slidesPerView: 2.2,
          },
          1025: {
            spaceBetween: 16,
            slidesPerView: 4,
          },
        },
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('community-slider', CommunitySlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /** Footer newsletter form -> Klaviyo, via the shared window.KlaviyoNewsletter. */
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('newsletter-footer');
    if (!form) return;

    const input = form.querySelector('#footer-newsletter-input');
    const message = form.querySelector('[data-newsletter-message]');
    const submitButton = form.querySelector('[type="submit"]');

    const showMessage = (text, isError) => {
      message.textContent = text;
      message.classList.remove('hidden');
      message.classList.toggle('footer_newsletter_message--error', !!isError);
    };

    input.addEventListener('input', () => message.classList.add('hidden'));

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const klaviyo = window.KlaviyoNewsletter;
      const email = input.value.trim();

      if (!email) return showMessage(form.dataset.emptyMessage, true);
      if (!klaviyo.isValidEmail(email)) return showMessage(form.dataset.invalidMessage, true);

      submitButton.setAttribute('disabled', '');

      try {
        await klaviyo.subscribe({
          email: email,
          listId: form.dataset.klaviyoListId,
          source: 'Footer Newsletter',
          properties: form.dataset.profileCountry ? { country_code: form.dataset.profileCountry } : undefined,
        });
        form.reset();
        showMessage(form.dataset.successMessage, false);
      } catch (error) {
        console.error('Klaviyo subscription error:', error);
        showMessage(form.dataset.errorMessage, true);
      } finally {
        submitButton.removeAttribute('disabled');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function checkScroll() {
    const scrollY = window.scrollY;
    const headerInner = document.querySelector(".header-inner");
    const isMobile = window.innerWidth < 768;

    const bodyLimit = isMobile ? 150 : 200;
    const headerLimit = isMobile ? 250 : 300;

    document.body.classList.toggle("scrolled", scrollY >= bodyLimit);
    headerInner.classList.toggle("scrolled-color", scrollY >= headerLimit);
  }

  window.addEventListener("scroll", checkScroll);
  window.addEventListener("load", checkScroll);
  window.addEventListener("resize", checkScroll);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductGallerySlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.mediaQuery = window.matchMedia('(max-width: 768px)');
      this.handleBreakpointChange = () => this.syncSwiper();
      this.mediaQuery.addEventListener('change', this.handleBreakpointChange);
      this.syncSwiper();
      this.observeVideos();
      this.retireReveal();
    }

    // .is-revealed only releases the reveal's `both` fill (see decisions.md).
    retireReveal() {
      const done = () => this.classList.add('is-revealed');
      const first = this.querySelector('.product-gallery-item');
      if (!first) return done();

      // `finished`, not animationend: deferred JS can run after it ended (see known-issues.md).
      const reveal = first
        .getAnimations?.()
        .find((animation) => animation.animationName === 'product-gallery-reveal');

      if (reveal) {
        reveal.finished.then(done, done);
      } else {
        done();
      }
    }

    disconnectedCallback() {
      this.mediaQuery.removeEventListener('change', this.handleBreakpointChange);
      this.destroySwiper();
      this.videoObserver?.disconnect();
    }

    observeVideos() {
      const videos = this.querySelectorAll('video');
      if (!videos.length) return;

      this.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.play();
            } else {
              entry.target.pause();
            }
          });
        },
        { threshold: 0.5 }
      );

      videos.forEach((video) => this.videoObserver.observe(video));
    }

    syncSwiper() {
      if (this.mediaQuery.matches) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    }

    initSwiper() {
      if (this.swiper || typeof Swiper === 'undefined') return;

      this.swiper = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
        },
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
        },
      });
    }

    destroySwiper() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
  customElements.define('product-gallery-slider', ProductGallerySlider);

  // --- Sticky buy buttons (mobile) ---
  // CSS sticky only pins the ATC before its slot; this keeps it pinned once scrolled past.
  class StickyBuyButtons extends HTMLElement {
    connectedCallback() {
      if (this.closest('quick-add-modal') || this.querySelector('recipient-form')) return;
      this.form = this.querySelector(':scope > product-form');
      if (!this.form) return;

      this.scrolledPast = false;
      this.mediaQuery = window.matchMedia('(max-width: 768px)');
      this.update = this.update.bind(this);
      this.mediaQuery.addEventListener('change', this.update);

      this.resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--sticky-buy-buttons-height', `${this.form.offsetHeight}px`);
      });
      this.resizeObserver.observe(this.form);

      // Scroll event, not IntersectionObserver: observer callbacks land after paint (see decisions.md).
      this.onScroll = () => {
        const { bottom } = this.getBoundingClientRect();
        this.scrolledPast = bottom <= 0;
        this.stuck = !this.scrolledPast && bottom >= window.innerHeight - 1;
        this.update();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
    }

    disconnectedCallback() {
      this.mediaQuery?.removeEventListener('change', this.update);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        document.documentElement.style.removeProperty('--sticky-buy-buttons-height');
      }
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
    }

    update() {
      this.classList.toggle('is-stuck', this.mediaQuery.matches && this.stuck);

      const pin = this.mediaQuery.matches && this.scrolledPast;
      if (pin === this.classList.contains('is-pinned')) return;

      if (pin) this.style.height = `${this.offsetHeight}px`;
      else this.style.removeProperty('height');
      this.classList.toggle('is-pinned', pin);
    }
  }
  customElements.define('sticky-buy-buttons', StickyBuyButtons);

  // Notify Me (back in stock) drawer
  // AMP back-in-stock app's global BIS.create(email, variantId, productId).
  class NotifyDrawer extends HTMLElement {
    connectedCallback() {
      // Drop duplicates a colour swap can leave behind (see known-issues.md).
      document.querySelectorAll(`[id="${this.id}"]`).forEach((element) => {
        if (element !== this) element.remove();
      });

      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return;
      }
      if (this.initialized) return;
      this.initialized = true;

      this.overlay = this.querySelector('.notify-drawer__overlay');
      this.form = this.querySelector('.notify-drawer__form');
      this.emailInput = this.querySelector('input[type="email"]');
      this.errorElement = this.querySelector('.input-error');
      this.fieldElement = this.querySelector('.field');
      this.closeButton = this.querySelector('.notify-drawer__close');
      this.keepShoppingButton = this.querySelector('.notify-drawer__keep-shopping');
      this.formState = this.querySelector('.notify-drawer__form-state');
      this.successState = this.querySelector('.notify-drawer__success-state');
      this.optionsElement = this.querySelector('[data-notify-options]');
      this.submitButton = this.querySelector('.notify-drawer__submit');
      this.emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      this.overlay.addEventListener('click', () => this.close());
      this.closeButton.addEventListener('click', () => this.close());
      this.keepShoppingButton.addEventListener('click', () => this.close());
      this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
      this.form.addEventListener('submit', (event) => this.handleSubmit(event));

      const inner = this.querySelector('.notify-drawer__inner');
      bindSwipeDownToClose(inner, inner, () => this.close());
    }

    open(opener) {
      this.opener = opener;
      this.hideError();
      this.buildSummary();
      this.formState.classList.remove('hidden');
      this.successState.classList.add('hidden');
      this.removeAttribute('inert');
      document.body.classList.add('overflow-hidden');

      clearTimeout(this.focusInputTimeout);
      if (window.matchMedia('(max-width: 768px)').matches) {
        trapFocus(this, this.closeButton);
        this.focusInputTimeout = setTimeout(() => this.emailInput.focus(), 600);
      } else {
        trapFocus(this, this.emailInput);
      }
    }

    close() {
      this.setAttribute('inert', '');
      document.body.classList.remove('overflow-hidden');
      clearTimeout(this.focusInputTimeout);
      removeTrapFocus(this.opener);
    }

    buildSummary() {
      const variantSelects = document.querySelector(`variant-selects[data-section="${this.dataset.section}"]`);
      const lines = [];
      if (variantSelects) {
        variantSelects.querySelectorAll('fieldset').forEach((fieldset) => {
          const legend = fieldset.querySelector('legend');
          const checked = fieldset.querySelector('input:checked');
          if (legend && checked) {
            const name = legend.textContent.split(':')[0].trim();
            lines.push(`<span>${name}: ${checked.value}</span>`);
          }
        });
      }
      this.optionsElement.innerHTML = lines.join('');
    }

    getVariantId() {
      const input = document.querySelector(`#product-form-${this.dataset.section} .product-variant-id`);
      return input ? input.value : null;
    }

    showError(message) {
      this.errorElement.querySelector('span').textContent = message;
      this.errorElement.classList.remove('hidden');
      this.fieldElement.classList.add('error');
    }

    hideError() {
      this.errorElement.classList.add('hidden');
      this.fieldElement.classList.remove('error');
    }

    handleSubmit(event) {
      event.preventDefault();
      const email = this.emailInput.value.trim();
      if (!this.emailPattern.test(email)) {
        this.showError(this.dataset.invalidEmailMessage);
        return;
      }

      const variantId = this.getVariantId();
      if (!variantId || typeof BIS === 'undefined') {
        this.showError(this.dataset.genericErrorMessage);
        return;
      }

      this.hideError();

      // BIS.create returns AMP's own promise (then only, no catch/reject), or undefined when misconfigured.
      let request;
      try {
        request = BIS.create(email, variantId, this.dataset.productId);
      } catch (error) {}
      if (!request || typeof request.then !== 'function') {
        this.showError(this.dataset.genericErrorMessage);
        return;
      }

      this.submitButton.disabled = true;
      // A failed JSONP request never resolves.
      const timeout = setTimeout(() => {
        this.submitButton.disabled = false;
        this.showError(this.dataset.genericErrorMessage);
      }, 10000);

      request.then((response) => {
        clearTimeout(timeout);
        this.submitButton.disabled = false;
        if (response && response.status === 'OK') {
          this.formState.classList.add('hidden');
          this.successState.classList.remove('hidden');
          this.emailInput.value = '';
        } else {
          this.showError(this.dataset.genericErrorMessage);
        }
      });
    }
  }
  customElements.define('notify-drawer', NotifyDrawer);

  class SizeGuideModal extends HTMLElement {
    connectedCallback() {
      // A colour swap briefly connects two copies; drop the stale one (see known-issues.md).
      document.querySelectorAll(`[id="${this.id}"]`).forEach((element) => {
        if (element !== this) element.remove();
      });

      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.close();
      });

      this.overlay = this.querySelector('.size-guide-modal__overlay');
      this.closeButton = this.querySelector('.size-guide-modal__close');
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.selectWrap = this.querySelector('.size-guide-modal__table-select');
      this.selectTrigger = this.querySelector('.size-guide-modal__select-trigger');
      this.selectList = this.querySelector('.size-guide-modal__select-list');
      this.selectLabel = this.querySelector('[data-selected-label]');
      this.selectOptions = [...this.querySelectorAll('.size-guide-modal__select-option')];
      this.tableWraps = [...this.querySelectorAll('.size-guide-modal__table-wrap')];
      this.unitButtons = [...this.querySelectorAll('[data-unit-value]')];
      this.unitsToggle = this.querySelector('.size-guide-modal__units');
      this.trigger = document.querySelector(`[aria-controls="${this.id}"]`);

      if (this.trigger) this.trigger.addEventListener('click', () => this.open());
      this.overlay.addEventListener('click', () => this.close());
      this.closeButton.addEventListener('click', () => this.close());
      this.addEventListener('keyup', (event) => {
        if (event.code !== 'Escape') return;
        if (this.selectList && !this.selectList.hidden) {
          this.closeSelect();
        } else {
          this.close();
        }
      });
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.selectTab(tab.dataset.tab)));
      if (this.selectTrigger) {
        this.selectTrigger.addEventListener('click', () => this.toggleSelect());
        document.addEventListener('click', (event) => {
          if (!this.selectWrap.contains(event.target)) this.closeSelect();
        });
      }
      this.selectOptions.forEach((option) => {
        option.addEventListener('click', () => {
          this.selectTable(option.dataset.tableIndex);
          this.selectOptions.forEach((other) => {
            other.classList.toggle('is-active', other === option);
            other.setAttribute('aria-selected', other === option);
          });
          if (this.selectLabel) this.selectLabel.textContent = option.textContent.trim();
          this.closeSelect();
        });
      });
      this.unitButtons.forEach((button) => {
        button.addEventListener('click', () => this.selectUnit(button.dataset.unitValue));
      });
      this.handleTabSwipes();
      bindSwipeDownToClose(
        this.querySelector('.size-guide-modal__inner'),
        this.querySelector('.size-guide-modal__body'),
        () => this.close()
      );
    }

    handleTabSwipes() {
      const mediaQuery = window.matchMedia('(max-width: 768px)');
      this.panels.forEach((panel) => {
        let startX = 0;
        let startY = 0;
        panel.addEventListener('touchstart', (event) => {
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        });
        panel.addEventListener('touchend', (event) => {
          if (!mediaQuery.matches) return;
          const deltaX = event.changedTouches[0].clientX - startX;
          const deltaY = event.changedTouches[0].clientY - startY;
          const minDistance = 50;
          if (Math.abs(deltaX) < minDistance || Math.abs(deltaX) < 1.5 * Math.abs(deltaY)) return;

          const activeIndex = this.tabs.findIndex((tab) => tab.classList.contains('is-active'));
          if (deltaX < 0) {
            if (this.tabs[activeIndex + 1]) this.selectTab(this.tabs[activeIndex + 1].dataset.tab);
          } else if (this.tabs[activeIndex - 1]) {
            this.selectTab(this.tabs[activeIndex - 1].dataset.tab);
          }
        });
      });
    }

    open() {
      // Reset while still inert so selectTab cannot pull focus ahead of closeButton.
      clearTimeout(this.resetTimer);
      this.resetState();
      this.removeAttribute('inert');
      document.body.classList.add('overflow-hidden');
      trapFocus(this, this.closeButton);
    }

    close() {
      this.setAttribute('inert', '');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.trigger);
      this.closeSelect();
      // Waits out the 0.3s close transition so it does not visibly snap back.
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => this.resetState(), 300);
    }

    resetState() {
      this.closeSelect();
      if (this.tabs[0]) this.selectTab(this.tabs[0].dataset.tab);

      const defaultOption = this.selectOptions[0];
      if (defaultOption) {
        this.selectOptions.forEach((option) => {
          option.classList.toggle('is-active', option === defaultOption);
          option.setAttribute('aria-selected', option === defaultOption);
        });
        if (this.selectLabel) this.selectLabel.textContent = defaultOption.textContent.trim();
      }

      if (this.tableWraps[0]) this.selectTable(this.tableWraps[0].dataset.tableIndex);
      if (this.unitButtons[0]) this.selectUnit(this.unitButtons[0].dataset.unitValue);
    }

    toggleSelect() {
      if (this.selectList.hidden) {
        this.openSelect();
      } else {
        this.closeSelect();
      }
    }

    openSelect() {
      this.selectList.hidden = false;
      this.selectTrigger.setAttribute('aria-expanded', 'true');
      trapFocus(this, this.selectTrigger);
    }

    closeSelect() {
      if (!this.selectList || this.selectList.hidden) return;
      this.selectList.hidden = true;
      this.selectTrigger.setAttribute('aria-expanded', 'false');
      if (!this.hasAttribute('inert')) trapFocus(this, this.selectTrigger);
    }

    selectTab(name) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tab === name;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });
      this.panels.forEach((panel) => panel.toggleAttribute('hidden', panel.dataset.panel !== name));

      const activeTab = this.tabs.find((tab) => tab.dataset.tab === name);
      if (activeTab && !this.hasAttribute('inert')) {
        // Blur first: focus() on an already-focused tab fires no focusin to re-arm the trap.
        removeTrapFocus();
        activeTab.blur();
        trapFocus(this, activeTab);
      }
    }

    selectTable(index) {
      const currentUnit = this.unitButtons.find((button) => button.classList.contains('is-active'))?.dataset.unitValue;
      this.tableWraps.forEach((wrap) => {
        const isActive = wrap.dataset.tableIndex === index;
        wrap.classList.toggle('is-active', isActive);
        if (isActive && currentUnit) wrap.dataset.unit = currentUnit;
      });
      // A table with no "in|cm" cells shows the toggle as Inch only.
      const activeWrap = this.tableWraps.find((wrap) => wrap.dataset.tableIndex === index);
      if (!activeWrap || !this.unitsToggle) return;
      const inchOnly = activeWrap.dataset.hasUnits !== 'true';
      this.unitsToggle.toggleAttribute('data-inch-only', inchOnly);
      if (inchOnly) this.selectUnit('in');
    }

    selectUnit(unit) {
      this.unitButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.unitValue === unit));
      const activeWrap = this.tableWraps.find((wrap) => wrap.classList.contains('is-active'));
      if (activeWrap) activeWrap.dataset.unit = unit;
    }
  }
  customElements.define('size-guide-modal', SizeGuideModal);

  // Warms linked colours' gallery images only; stock still comes from a fresh fetch on swap.
  window.addEventListener('load', () => {
    setTimeout(() => {
      const galleryUrls = new Set();
      document.querySelectorAll('variant-selects [data-product-url]').forEach((input) => {
        const url = input.getAttribute('data-product-url');
        if (url) galleryUrls.add(url);
      });

      galleryUrls.forEach((url) => {
        fetch(`${url}?section_id=product-gallery-preload-api`)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            doc.querySelectorAll('.product-gallery-item img').forEach((sourceImage) => {
              const image = new Image();
              if (sourceImage.sizes) image.sizes = sourceImage.sizes;
              if (sourceImage.srcset) image.srcset = sourceImage.srcset;
              image.src = sourceImage.src;
            });
          })
          .catch(() => {});
      });
    }, 5000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-products"] && !Shopify.designMode) return;
  try {
    
  // Moved from rAF, not a CSS animation: Safari 26 sticks :hover on animated tracks (see known-issues.md).
  const SCROLLING_PRODUCTS_DRAG_THRESHOLD = 5;
  // Momentum decay per 16.7ms frame, and the speed below which it stops.
  const SCROLLING_PRODUCTS_FRICTION = 0.95;
  const SCROLLING_PRODUCTS_MIN_VELOCITY = 0.02;
  // Quiet time after the last wheel event before the drift picks up again.
  const SCROLLING_PRODUCTS_WHEEL_IDLE = 200;

  class ScrollingProductsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.scrolling_products_track');
      if (!this.track) return;

      this.x = 0;
      this.velocity = 0;
      this.hovered = false;
      this.drag = null;
      this.visible = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.measure();
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.track);

      // Only spend frames while the row is on screen.
      this.intersectionObserver = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.start();
      });
      this.intersectionObserver.observe(this);

      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.hovered = true;
      });
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        this.start();
      });

      this.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.addEventListener('pointercancel', (event) => this.onPointerUp(event));

      // A drag that ends over a product must not also open it.
      this.addEventListener(
        'click',
        (event) => {
          if (!this.suppressClick) return;
          this.suppressClick = false;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
      // The browser's own image/link drag would otherwise take the gesture.
      this.addEventListener('dragstart', (event) => event.preventDefault());

      // Not passive: an unclaimed horizontal swipe is back/forward navigation in Safari.
      this.addEventListener('wheel', (event) => this.onWheel(event), { passive: false });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    measure() {
      this.setWidth = this.track.scrollWidth / 3;
      // One set per `speed` seconds.
      this.speed = this.setWidth / (Number(this.dataset.duration || 25) * 1000);
      this.render();
    }

    // Keep x within (-setWidth, 0], so the loop never runs out of track.
    wrap(x) {
      if (!this.setWidth) return x;
      return ((x % this.setWidth) - this.setWidth) % this.setWidth;
    }

    render() {
      this.x = this.wrap(this.x);
      this.track.style.transform = `translate3d(${this.x}px, 0, 0)`;
    }

    drifting() {
      return !this.hovered && !this.drag && !this.wheeling() && !this.reducedMotion.matches;
    }

    // A touchpad swipe has no end event; a short gap ends it.
    wheeling() {
      return performance.now() < (this.wheelUntil || 0);
    }

    // Only mostly-horizontal swipes; raw deltas, since the OS already supplies momentum.
    onWheel(event) {
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

      event.preventDefault();

      const scale = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? this.clientWidth : 1;

      this.velocity = 0;
      this.x -= event.deltaX * scale;
      this.wheelUntil = performance.now() + SCROLLING_PRODUCTS_WHEEL_IDLE;
      this.render();
      this.start();
    }

    start() {
      if (this.frame || !this.visible) return;
      this.lastTime = performance.now();
      this.frame = requestAnimationFrame((time) => this.tick(time));
    }

    tick(time) {
      this.frame = null;
      // Capped, so a tab returning from the background does not leap.
      const elapsed = Math.min(time - this.lastTime, 64);
      this.lastTime = time;

      const frames = elapsed / (1000 / 60);
      let moving = false;

      if (Math.abs(this.velocity) > SCROLLING_PRODUCTS_MIN_VELOCITY) {
        this.x += this.velocity * elapsed;
        this.velocity *= Math.pow(SCROLLING_PRODUCTS_FRICTION, frames);
        moving = true;
      } else {
        this.velocity = 0;
      }

      if (this.drifting()) {
        this.x -= this.speed * elapsed;
        moving = true;
      }

      if (moving) this.render();

      if ((moving || this.drag || this.wheeling()) && this.visible) {
        this.frame = requestAnimationFrame((next) => this.tick(next));
      }
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      this.velocity = 0;
      // A drag released outside never gets its click, so reset the flag here.
      this.suppressClick = false;
      this.drag = {
        id: event.pointerId,
        startX: event.clientX,
        startTranslate: this.x,
        lastX: event.clientX,
        lastTime: event.timeStamp,
        velocity: 0,
        active: false,
      };
    }

    onPointerMove(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;

      const delta = event.clientX - drag.startX;

      if (!drag.active) {
        if (Math.abs(delta) < SCROLLING_PRODUCTS_DRAG_THRESHOLD) return;
        // Captured only once it is a drag, so a plain click still opens the product.
        drag.active = true;
        this.setPointerCapture(event.pointerId);
        this.classList.add('is-dragging');
      }

      const dt = event.timeStamp - drag.lastTime;
      if (dt > 0) {
        // Smoothed, so one jittery last event does not decide the fling.
        drag.velocity = drag.velocity * 0.6 + ((event.clientX - drag.lastX) / dt) * 0.4;
      }
      drag.lastX = event.clientX;
      drag.lastTime = event.timeStamp;

      this.x = drag.startTranslate + delta;
      this.render();
    }

    onPointerUp(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;

      this.drag = null;

      if (drag.active) {
        this.classList.remove('is-dragging');
        if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
        // A pause before letting go means the shopper stopped it there.
        const held = event.timeStamp - drag.lastTime > 100;
        this.velocity = event.type === 'pointercancel' || held ? 0 : drag.velocity;
        this.suppressClick = event.type === 'pointerup';
      }

      this.start();
    }
  }

  customElements.define('scrolling-products-slider', ScrollingProductsSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sell-back"]) return;
  try {
    
  class SellBackForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-sell-back-status]');
      this.submitButton = this.querySelector('.sell-back-form_submit');

      ['first_name', 'last_name', 'quantity'].forEach((name) => {
        this.form.elements[name].addEventListener('input', (event) => {
          const isEmpty = event.target.value.trim() === '';
          this.setFieldError(event.target, false);
          if (!isEmpty) this.hideStatus();
        });
      });

      const emailInput = this.form.elements['email'];
      emailInput.addEventListener('input', () => {
        const value = emailInput.value.trim();
        const isInvalidEmail = value !== '' && !this.isValidEmail(value);
        this.setFieldError(emailInput, isInvalidEmail);
        if (!isInvalidEmail) this.hideStatus();
      });

      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
    }

    isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    setFieldError(input, hasError) {
      const field = input.closest('.field');
      if (field) field.classList.toggle('error', hasError);
    }

    showStatus(message, isError) {
      this.status.textContent = message;
      this.status.classList.toggle('sell-back-form_status--success', !isError);
      this.status.hidden = false;
    }

    hideStatus() {
      this.status.hidden = true;
    }

    handleSubmit(event) {
      event.preventDefault();

      const formData = new FormData(this.form);
      const firstName = formData.get('first_name').trim();
      const lastName = formData.get('last_name').trim();
      const email = formData.get('email').trim();
      const quantity = formData.get('quantity').trim();
      const comments = formData.get('comments').trim();
      const deliveryMethod = formData.get('delivery_method');

      const requiredFields = [
        [this.form.elements['first_name'], firstName],
        [this.form.elements['last_name'], lastName],
        [this.form.elements['email'], email],
        [this.form.elements['quantity'], quantity],
      ];

      let hasError = false;
      requiredFields.forEach(([input, value]) => {
        // checkValidity() also applies the field's own min/max/step (quantity).
        const isEmpty = value === '' || !input.checkValidity();
        this.setFieldError(input, isEmpty);
        if (isEmpty) hasError = true;
      });

      const isInvalidEmail = email !== '' && !this.isValidEmail(email);
      if (isInvalidEmail) {
        this.setFieldError(this.form.elements['email'], true);
        hasError = true;
      }

      if (hasError) {
        this.showStatus(isInvalidEmail ? this.dataset.emailErrorMessage : this.dataset.requiredMessage, true);
        return;
      }

      this.submitButton.disabled = true;

      fetch(this.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: firstName,
          surname: lastName,
          email: email,
          customer_id: this.dataset.customerId,
          comments: comments,
          quantity: quantity,
          in_store: deliveryMethod === 'in_store' ? 1 : 0,
          shipping_label: deliveryMethod === 'shipping_label' ? 1 : 0,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.submitButton.disabled = false;
          if (data && data.status) {
            this.showStatus(this.dataset.successMessage, false);
            this.form.reset();
          } else {
            this.showStatus(this.dataset.errorMessage, true);
          }
        })
        .catch(() => {
          this.submitButton.disabled = false;
          this.showStatus(this.dataset.errorMessage, true);
        });
    }
  }
  customElements.define('sell-back-form', SellBackForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide-table"] && !Shopify.designMode) return;
  try {
    
  // Grouping runs inline at parse time (size-guide-table-group); this adds interaction only.
  if (!customElements.get('size-guide-table')) {
    class SizeGuideTable extends HTMLElement {
      // Batched: one regroup per frame however many sections connect.
      static scheduleRegroup() {
        if (SizeGuideTable.regroupFrame) return;
        SizeGuideTable.regroupFrame = requestAnimationFrame(() => {
          SizeGuideTable.regroupFrame = null;
          document.querySelectorAll('size-guide-table').forEach((element) => element.build());
        });
      }

      connectedCallback() {
        if (!this.initialized) {
          this.initialized = true;
          this.tablist = this.querySelector('.size-guide-page_tabs');

          this.tablist.addEventListener('click', (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (tab) this.choose(tab.dataset.sectionId);
          });
          this.tablist.addEventListener('keydown', (event) => this.onTabKeydown(event));
          this.querySelectorAll('[data-unit-value]').forEach((button) => {
            button.addEventListener('click', () => {
              this.dataset.unit = button.dataset.unitValue;
              window.SizeGuideTables.applyUnit(this);
            });
          });

          // Options are rebuilt on every regroup, so listen on the list.
          this.selectWrap = this.querySelector('.size-guide-page_select');
          this.selectTrigger = this.querySelector('.size-guide-page_select-trigger');
          this.selectList = this.querySelector('.size-guide-page_select-list');
          this.selectTrigger.addEventListener('click', () => this.toggleSelect());
          this.selectList.addEventListener('click', (event) => {
            const option = event.target.closest('[role="option"]');
            if (!option) return;
            this.choose(option.dataset.sectionId);
            this.closeSelect(true);
          });
          this.selectWrap.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape' || this.selectList.hidden) return;
            event.stopPropagation();
            this.closeSelect(true);
          });
          this.onOutsideClick = (event) => {
            if (!this.selectWrap.contains(event.target)) this.closeSelect();
          };
        }
        SizeGuideTable.scheduleRegroup();
      }

      disconnectedCallback() {
        this.closeSelect();
        SizeGuideTable.scheduleRegroup();
      }

      toggleSelect() {
        if (this.selectList.hidden) {
          this.selectList.hidden = false;
          this.selectTrigger.setAttribute('aria-expanded', 'true');
          document.addEventListener('click', this.onOutsideClick);
          const current = this.selectList.querySelector('[aria-selected="true"]') || this.selectList.querySelector('[role="option"]');
          if (current) current.focus();
        } else {
          this.closeSelect(true);
        }
      }

      closeSelect(returnFocus = false) {
        if (!this.selectList || this.selectList.hidden) return;
        this.selectList.hidden = true;
        this.selectTrigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onOutsideClick);
        if (returnFocus) this.selectTrigger.focus();
      }

      build() {
        window.SizeGuideTables.build(this);
      }

      // A pick by the shopper, which outranks a shared link from here on.
      choose(sectionId, focus = false) {
        this.dataset.active = sectionId;
        window.SizeGuideTables.select(this, sectionId);
        const tab = this.tablist.querySelector('[aria-selected="true"]');
        if (focus) tab.focus({ preventScroll: true });
        this.updateUrl();
      }

      // The first tab is the default, so it clears the param.
      updateUrl() {
        const tabs = window.SizeGuideTables.tabsOf(this);
        const activeTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
        const param = window.SizeGuideTables.URL_PARAM;
        const url = new URL(window.location.href);
        if (!activeTab || activeTab === tabs[0]) {
          url.searchParams.delete(param);
        } else {
          url.searchParams.set(param, activeTab.dataset.tabHandle);
        }
        window.history.replaceState(window.history.state, '', url);
      }

      onTabKeydown(event) {
        const tabs = window.SizeGuideTables.tabsOf(this);
        if (tabs.length < 2) return;
        const index = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        let next;
        switch (event.key) {
          case 'ArrowRight':
            next = (index + 1) % tabs.length;
            break;
          case 'ArrowLeft':
            next = (index - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = tabs.length - 1;
            break;
          default:
            return;
        }
        event.preventDefault();
        this.choose(tabs[next].dataset.sectionId, true);
      }
    }

    customElements.define('size-guide-table', SizeGuideTable);

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:reorder', () => SizeGuideTable.scheduleRegroup());
      // A selected follower shows its tab on the leader.
      ['shopify:section:select', 'shopify:block:select'].forEach((eventName) => {
        document.addEventListener(eventName, (event) => {
          const wrapper = document.getElementById(`shopify-section-${event.detail.sectionId}`);
          const leader = window.SizeGuideTables.leaderOf(wrapper);
          if (!leader) return;
          leader.dataset.active = event.detail.sectionId;
          window.SizeGuideTables.select(leader, event.detail.sectionId);
          if (leader.dataset.sectionId !== event.detail.sectionId) {
            leader.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utility-content"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.utility-content').forEach((root) => {
    const nav = root.querySelector('.utility-nav-links');
    const contentEl = root.querySelector('.utility-pages-content');
    if (!nav || !contentEl) return;

    const links = Array.from(nav.querySelectorAll('a[href]')).filter(
      (link) => link.origin === window.location.origin
    );
    if (links.length === 0) return;

    const cache = new Map();
    let currentUrl = root.dataset.currentUrl || window.location.pathname;
    let abortController = null;

    function normalize(url) {
      try {
        return new URL(url, window.location.origin).pathname;
      } catch (error) {
        return url;
      }
    }

    const titleEl = document.querySelector('head title');
    cache.set(normalize(currentUrl), {
      titleHtml: titleEl ? titleEl.innerHTML : document.title,
      html: contentEl.innerHTML,
    });

    function setActiveLink(url) {
      const target = normalize(url);
      links.forEach((link) => {
        const isActive = normalize(link.getAttribute('href')) === target;
        link.classList.toggle('link--underline', isActive);
        link.classList.toggle('link', !isActive);
      });
    }

    function fetchPage(url, signal) {
      const key = normalize(url);
      if (cache.has(key)) return Promise.resolve(cache.get(key));
      return fetch(url, signal ? { signal } : undefined)
        .then((response) => response.text())
        .then((responseText) => {
          const doc = new DOMParser().parseFromString(responseText, 'text/html');
          const fetchedContent = doc.querySelector('.utility-pages-content');
          const entry = {
            titleHtml: doc.querySelector('title') ? doc.querySelector('title').innerHTML : document.title,
            html: fetchedContent ? fetchedContent.innerHTML : null,
          };
          if (entry.html !== null) cache.set(key, entry);
          return entry;
        });
    }

    function renderPage(entry, url, options) {
      contentEl.innerHTML = entry.html;
      const currentTitleEl = document.querySelector('head title');
      if (currentTitleEl) currentTitleEl.innerHTML = entry.titleHtml;
      setActiveLink(url);
      currentUrl = url;
      if (!options.skipHistory) history.pushState({ utilityContentUrl: url }, '', url);

      contentEl.style.animation = 'none';
      void contentEl.offsetHeight;
      contentEl.style.animation = '';

      const utilel = document.querySelector('.section-utility-content');
      const rect = utilel.getBoundingClientRect();
      if (rect.top < 0 || rect.top > window.innerHeight) {
      const headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position')) || 0;
        window.scrollTo({ top: window.scrollY + rect.top - headerOffset, behavior: 'smooth' });
      }
    }

    function navigateTo(url, options) {
      options = options || {};
      if (!options.force && normalize(url) === normalize(currentUrl)) return;

      abortController && abortController.abort();
      abortController = new AbortController();
      root.classList.add('utility-content--loading');

      fetchPage(url, abortController.signal)
        .then((entry) => {
          root.classList.remove('utility-content--loading');
          if (entry.html === null) {
            window.location.href = url;
            return;
          }
          renderPage(entry, url, options);
        })
        .catch((error) => {
          root.classList.remove('utility-content--loading');
          if (error.name === 'AbortError') return;
          window.location.href = url;
        });
    }

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        navigateTo(link.href);
      });
    });

    window.addEventListener('popstate', () => {
      navigateTo(window.location.pathname, { skipHistory: true, force: true });
    });

    window.addEventListener('load', () => {
      setTimeout(() => {
        links.forEach((link) => fetchPage(link.href));
      }, 1000);
    });

    const mobileQuery = window.matchMedia('(max-width: 768px)');
    let touchStartX = 0;
    let touchStartY = 0;
    contentEl.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    });
    contentEl.addEventListener('touchend', (event) => {
      if (!mobileQuery.matches) return;
      const deltaX = event.changedTouches[0].clientX - touchStartX;
      const deltaY = event.changedTouches[0].clientY - touchStartY;
      const minDistance = 50;
      if (Math.abs(deltaX) < minDistance || Math.abs(deltaX) < 1.5 * Math.abs(deltaY)) return;

      const activeIndex = links.findIndex((link) => normalize(link.getAttribute('href')) === normalize(currentUrl));
      if (activeIndex === -1) return;
      if (deltaX < 0) {
        if (links[activeIndex + 1]) navigateTo(links[activeIndex + 1].href);
      } else if (links[activeIndex - 1]) {
        navigateTo(links[activeIndex - 1].href);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
